import { IFlowyProject, IFlowyRoute, IRootGizmoData } from '../types';
import { init } from './project-functions';

interface IFlowyProjectConstructor {
  /**
   * This is the base route where the project component is located, we did this in order to use the
   * FlowyProject in any route
   */
  basePath: string;
  /**
   * Current route in the project
   */
  path: string;
  config?: IFlowyProject;
  data?: IRootGizmoData[];
}

class FlowyProject {
  private _basePath: string;
  private _path: string;

  private _config?: IFlowyProject;
  private _data?: IRootGizmoData[];

  // Current root gizmo configs, the ones involved with the current route
  // private _rootGizmoConfigs?: IGizmo[];
  private _flowyRoutes: IFlowyRoute[] = [];

  constructor({ config, data, basePath, path }: IFlowyProjectConstructor) {
    this._basePath = basePath;
    this._path = path;

    this._config = config;
    this._data = data;
  }

  public init = (): Promise<FlowyProject> => {
    return new Promise<FlowyProject>(async resolve => {
      const { flowyRoutes } = await init({
        config: this._config,
        context: {
          basePath: this._basePath,
          path: this._path,
        },
      });

      this._flowyRoutes = flowyRoutes;

      resolve(this);
    });
  };

  /**
   * Get the route objects that will be used to render the routes on the UI layer
   * @returns routes
   */
  public getFlowyRoutes = (): IFlowyRoute[] => {
    return this._flowyRoutes;
  };

  /**
   * Set the current UI layer route
   * @param {string} path current route in the ui layer
   */
  // public setPath = (path: string) => {
  //   this._path = path;
  // };

  public getConfig = (): IFlowyProject | undefined => {
    return this._config;
  };

  public getData = (): IRootGizmoData[] | undefined => {
    return this._data;
  };
}

export default FlowyProject;
